import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ChatPanelHostComponent } from '@modules/spaces/chat/ui/chat-panel-host/chat-panel-host.component';
import { TopProgressTaskComponent } from '@modules/top-progress/top-progress-task.component';

/** Load team Chat only when the panel's Chat view is selected. */
@Component({
  selector: 'app-lazy-space-chat-panel',
  imports: [ChatPanelHostComponent, TopProgressTaskComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex h-full min-h-0 flex-col' },
  template: `@defer (on immediate) {
      <stch-space-chat-ui-panel-host />
    } @loading {
      <stch-top-progress-task />
    }`,
})
export class LazySpaceChatPanelComponent {}
